<template>
  <SimpleDataWithVariation
    :title="title"
    :item-id="itemId"
    :value="value"
    :variation="variation"
    :raw-variation="rawVariation"
    :request-status="requestStatus"
    :comparation-value="comparationValue"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import SimpleDataWithVariation from '@/components/cards/models/SimpleDataWithVariation';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
import { calculateVariation } from '@/utils/math';
import { VARIATION_TYPE } from '@/store/modules/cards/constants';

export default {
  name: 'FansTotal',
  components: {
    SimpleDataWithVariation,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      value: '',
      variation: '',
      rawVariation: '',
      comparationValue: '',
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getPerformancePageMetricsServiceWithVariation',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getPerformancePageMetricsServiceWithVariation({
        itemId: this.itemId,
        servicePath: 'metricsOverview',
      })
        .then(response => {
          const previousFilteresResponse = this.getFilteredData(response[0]);
          const filteresResponse = this.getFilteredData(response[1]);

          const variation = calculateVariation(previousFilteresResponse.total, filteresResponse.total);

          this.value = filteresResponse.total;
          this.variation = variation;
          this.rawVariation = variation;
          this.comparationValue = previousFilteresResponse.total;
          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
    verifyVariation(followers) {
      return VARIATION_TYPE.DOWN === followers.type ? followers.details * -1 : followers.details;
    },
    getFilteredData(data) {
      return data
        .filter(resource => resource.status === 'fulfilled' && resource.value.hasOwnProperty('followers'))
        .map(resource => resource.value.followers.total)
        .reduce((reduceObj, followers) => ({
          total: reduceObj.total + followers.value,
          variation: reduceObj.variation + this.verifyVariation(followers),
        }), { total: 0, variation: 0 });
    },
  },
};
</script>

